const MQ = window.matchMedia('(min-width: 1024px)');
const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
const elements = Array.from(document.querySelectorAll('[data-parallax]'));

let ticking = false;
let active = false;

const update = () => {
  const center = window.innerHeight / 2;

  elements.forEach((el) => {
    const speed = parseFloat(el.getAttribute('data-parallax')) || 0;
    const rect = el.getBoundingClientRect();
    const offset = (rect.top + rect.height / 2 - center) * speed;
    el.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
  });

  ticking = false;
};

const onScroll = () => {
  if (!ticking) {
    window.requestAnimationFrame(update);
    ticking = true;
  }
};

const enable = () => {
  if (active) return;
  active = true;
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
};

const disable = () => {
  if (!active) return;
  active = false;
  window.removeEventListener('scroll', onScroll);
  window.removeEventListener('resize', onScroll);
  elements.forEach((el) => {
    el.style.transform = '';
  });
};

if (elements.length && !REDUCE.matches) {
  if (MQ.matches) enable();

  MQ.addEventListener('change', (e) => {
    if (e.matches) enable();
    else disable();
  });
}
